// ==================================================================================
// GOOGLE ADS CONVERSION TRACKING
// ==================================================================================

(function initializeGoogleAdsTracking() {
  const GOOGLE_ADS_ID = 'AW-624342049';

  window.dataLayer = window.dataLayer || [];

  if (typeof window.gtag !== 'function') {
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
  }

  if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
    const script = document.createElement('script');
    script.async = true;
    script.src =
      'https://www.googletagmanager.com/gtag/js?id=' +
      encodeURIComponent(GOOGLE_ADS_ID);

    document.head.appendChild(script);
  }

  if (!window.__breezeGoogleTagInitialized) {
    window.gtag('js', new Date());
    window.__breezeGoogleTagInitialized = true;
  }

  window.gtag('config', GOOGLE_ADS_ID);
})();

// ==================================================================================
// CONFIGURATION
// ==================================================================================

const BREEZE_GOOGLE_ADS_CONFIG = {
  purchaseDestination: 'AW-624342049/cN7XCLjwu6gcEKHo2qkC',
  beginCheckoutDestination: 'AW-624342049/TdLkCJympaQcEKHo2qkC',

  // Add the conversion label here when available
  addPaymentInfoDestination: null
};

// ==================================================================================
// ORDER PLACED (PURCHASE)
// ==================================================================================

['order-placed', 'breeze-order-placed', 'breeze-purchase'].forEach(function (eventName) {
  window.addEventListener(eventName, function (event) {
    const params = getBreezeEventData(event, 'Order Placed');

    if (!params) {
      return;
    }

    try {
      sendGoogleAdsPurchase(params);
    } catch (error) {
      logTrackingError('Google Ads order-placed', error);
    }
  });
});

function sendGoogleAdsPurchase(params) {
  const items = createGoogleAdsItems(params.items);
  const userDetails = params.userDetails || params.customer || params.user || {};
  const userData = createGoogleUserData(userDetails);

  const currency = params.currency || 'INR';
  const value = toNumber(params.totalPrice);
  const tax = toNumber(params.tax);
  const shipping = toNumber(
    params.shippingCharge !== undefined
      ? params.shippingCharge
      : params.shipping
  );

  window.dataLayer.push({
    event: 'order-placed',
    event_source: 'breeze',
    user_data: userData,
    user_details: userDetails,
    ecommerce: {
      transaction_id: String(params.shopOrderId || ''),
      currency: currency,
      value: value,
      tax: tax,
      shipping: shipping,
      items: createDataLayerItems(params.items)
    },
    breeze_event_type: 'order-placed',
    breeze_event_time: new Date().toISOString()
  });

  const conversionPayload = {
    send_to: [BREEZE_GOOGLE_ADS_CONFIG.purchaseDestination],
    developer_id: {
      dNzYwYj: true
    },
    transaction_id: String(params.shopOrderId || ''),
    value: value,
    currency: currency,
    tax: tax,
    shipping: shipping,
    items: items,
    user_data: userData,
    customer_type: params.customerType || '',
    payment_type: params.paymentMethodType || '',
    google_analysis_params: {
      lineItemValue: calculateItemsValue(items),
      totalPriceValue: value
    },
    breeze_event_type: 'order-placed',
    breeze_event_time: new Date().toISOString()
  };

  window.gtag('event', 'purchase', conversionPayload);
}

// ==================================================================================
// CHECKOUT INIT (BEGIN CHECKOUT)
// ==================================================================================

['checkout-init', 'breeze-checkout-init', 'breeze-initiate-checkout'].forEach(function (eventName) {
  window.addEventListener(eventName, function (event) {
    const params = getBreezeEventData(event, 'Checkout Init');

    if (!params) {
      return;
    }

    try {
      sendGoogleAdsBeginCheckout(params);
    } catch (error) {
      logTrackingError('Google Ads checkout-init', error);
    }
  });
});

function sendGoogleAdsBeginCheckout(params) {
  const items = createGoogleAdsItems(params.items);
  const userDetails = params.userDetails || params.customer || params.user || {};
  const userData = createGoogleUserData(userDetails);

  const currency = params.currency || 'INR';
  const value = toNumber(params.totalPrice);

  window.dataLayer.push({
    event: 'checkout-init',
    event_source: 'breeze',
    user_data: userData,
    user_details: userDetails,
    ecommerce: {
      currency: currency,
      value: value,
      items: createDataLayerItems(params.items)
    },
    breeze_event_type: 'checkout-init',
    breeze_event_time: new Date().toISOString()
  });

  const conversionPayload = {
    send_to: [BREEZE_GOOGLE_ADS_CONFIG.beginCheckoutDestination],
    developer_id: {
      dNzYwYj: true
    },
    ecomm_prodid: items.map(function (item) {
      return item.id;
    }),
    ecomm_totalvalue: value,
    ecomm_pagetype: 'cart',
    value: value,
    currency: currency,
    items: items,
    user_data: userData,
    google_analysis_params: {
      lineItemValue: calculateItemsValue(items),
      totalPriceValue: value
    },
    breeze_event_type: 'checkout-init',
    breeze_event_time: new Date().toISOString()
  };

  window.gtag('event', 'begin_checkout', conversionPayload);
}

// ==================================================================================
// PAYMENT SCREEN (ADD PAYMENT INFO)
// ==================================================================================

['payment-screen', 'breeze-payment-screen', 'breeze-add-payment-info'].forEach(function (eventName) {
  window.addEventListener(eventName, function (event) {
    const params = getBreezeEventData(event, 'Payment Screen');

    if (!params) {
      return;
    }

    try {
      sendGoogleAdsAddPaymentInfo(params);
    } catch (error) {
      logTrackingError('Google Ads payment-screen', error);
    }
  });
});

function sendGoogleAdsAddPaymentInfo(params) {
  const items = createGoogleAdsItems(params.items);
  const userDetails = params.userDetails || params.customer || params.user || {};
  const userData = createGoogleUserData(userDetails);

  const currency = params.currency || 'INR';
  const value = toNumber(params.totalPrice);

  window.dataLayer.push({
    event: 'payment-screen',
    event_source: 'breeze',
    user_data: userData,
    user_details: userDetails,
    ecommerce: {
      currency: currency,
      value: value,
      payment_type: params.paymentMethodType || '',
      items: createDataLayerItems(params.items)
    },
    breeze_event_type: 'payment-screen',
    breeze_event_time: new Date().toISOString()
  });

  if (!BREEZE_GOOGLE_ADS_CONFIG.addPaymentInfoDestination) {
    console.warn(
      'Google Ads payment-screen was not sent because its conversion label is not configured.'
    );
    return;
  }

  const conversionPayload = {
    send_to: [BREEZE_GOOGLE_ADS_CONFIG.addPaymentInfoDestination],
    developer_id: {
      dNzYwYj: true
    },
    currency: currency,
    value: value,
    items: items,
    user_data: userData,
    payment_type: params.paymentMethodType || '',
    breeze_event_type: 'payment-screen',
    breeze_event_time: new Date().toISOString()
  };

  window.gtag('event', 'add_payment_info', conversionPayload);
}

// ==================================================================================
// SHARED UTILITIES
// ==================================================================================

function getBreezeEventData(event, eventName) {
  if (!event || !event.detail || !event.detail.data) {
    console.error(
      eventName + ': invalid event data. Expected event.detail.data.'
    );

    return null;
  }

  return event.detail.data;
}

function createGoogleAdsItems(items) {
  if (!Array.isArray(items)) {
    console.error('Invalid items array:', items);
    return [];
  }

  return items.map(function (item) {
    return {
      id:
        'shopify_IN_' +
        String(item.id || '') +
        '_' +
        String(item.variant || ''),
      name: item.name || '',
      brand: item.vendor || '',
      category: item.productType || '',
      coupon: item.discount || '',
      price: toNumber(item.price),
      quantity: toNumber(item.quantity),
      variant: item.variantTitle || ''
    };
  });
}

function createDataLayerItems(items) {
  if (!Array.isArray(items)) {
    return [];
  }

  return items.map(function (item, index) {
    return {
      item_id: String(item.id || ''),
      item_name: item.name || '',
      item_brand: item.vendor || '',
      item_category: item.productType || '',
      item_variant: String(item.variant || ''),
      coupon: item.discount || '',
      price: toNumber(item.price),
      quantity: toNumber(item.quantity),
      currency: item.currency || 'INR',
      index: index
    };
  });
}

function createGoogleUserData(userData) {
  if (!userData || typeof userData !== 'object') {
    return undefined;
  }

  return {
    email: userData.email || '',
    phone_number: userData.phone || userData.phoneNumber || '',
    address: {
      first_name: userData.firstName || userData.name || '',
      last_name: userData.lastName || '',
      street: userData.address || userData.street || '',
      city: userData.city || '',
      region: userData.state || userData.region || '',
      postal_code: userData.postalCode || userData.zip || userData.zipCode || '',
      country: userData.country || 'IN'
    }
  };
}

function calculateItemsValue(items) {
  return items.reduce(function (total, item) {
    return total + toNumber(item.price) * toNumber(item.quantity);
  }, 0);
}

function toNumber(value) {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : 0;
}

function logTrackingError(source, error) {
  console.error(source + ' failed:', error);

  if (error && error.stack) {
    console.error(error.stack);
  }
}